import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  option: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    paddingBlock: theme.spacing(0.5),
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
}))

export default styles
